export const LOST = "LOST";
export const OPEN = "OPEN";
export const WON = "WON";

export const isOpen = (state) => ![LOST, WON].includes(state.systemKey);

export const values = [LOST, OPEN, WON];
